module.exports = __webpack_public_path__ + "static/media/big-game.47ee513e.png";